var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172.03,
    height: 105.32,
    strokeMiterlimit: 10,
    style: {
      fill: "none",
      strokeLinecap: "square",
      strokeMiterlimit: 10
    },
    viewBox: "0 0 172.03 105.32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h960v540h-960z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m33.853 38.036c-2.5408-10.411 2.356-20.059 10.937-21.55 4.1208-0.71607 8.5576 0.58317 12.334 3.6119 3.7766 3.0287 6.5838 7.5388 7.8039 12.538 2.5408 10.411-2.356 20.059-10.937 21.55-8.5812 1.4911-17.597-5.7395-20.138-16.15z",
    style: {
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.853 38.036c-2.5408-10.411 2.356-20.059 10.937-21.55 4.1208-0.71607 8.5576 0.58317 12.334 3.6119 3.7766 3.0287 6.5838 7.5388 7.8039 12.538 2.5408 10.411-2.356 20.059-10.937 21.55-8.5812 1.4911-17.597-5.7395-20.138-16.15z",
    style: {
      fillRule: "evenodd",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#f67535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.715 21.006c1.5978 5.2991 10.43 19.118 9.5868 31.795-0.84329 12.677-20.727 38.236-14.647 44.266 6.0805 6.0295 41.765-2.659 51.13-8.0892 9.3649-5.4302-2.7074-11.085 5.0597-24.492 7.7671-13.407 36.572-46.775 41.543-55.95 4.9709-9.1752-3.9945-6.5912-11.717 0.8988-7.7227 7.49-25.21 37.263-34.619 44.041-9.4093 6.7785-15.046 4.157-21.837-3.3705s-13.981-34.042-18.907-41.794c-4.9265-7.7522-9.8087-7.1343-10.652-4.7187-0.84327 2.4156 4.6602 16.01 5.5923 19.212",
    style: {
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.715 21.006c1.5978 5.2991 10.43 19.118 9.5868 31.795-0.84329 12.677-20.727 38.236-14.647 44.266 6.0805 6.0295 41.765-2.659 51.13-8.0892 9.3649-5.4302-2.7074-11.085 5.0597-24.492 7.7671-13.407 36.572-46.775 41.543-55.95 4.9709-9.1752-3.9945-6.5912-11.717 0.8988-7.7227 7.49-25.21 37.263-34.619 44.041-9.4093 6.7785-15.046 4.157-21.837-3.3705s-13.981-34.042-18.907-41.794c-4.9265-7.7522-9.8087-7.1343-10.652-4.7187-0.84327 2.4156 4.6602 16.01 5.5923 19.212",
    style: {
      fillRule: "evenodd",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#f67535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.21 75.945-135.82 27.417",
    style: {
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.21 75.945-135.82 27.417",
    style: {
      fillRule: "evenodd",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#f67535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.38 83.136-42.608 9.8868 63.646 8.5386 3.4619-16.178z",
    style: {
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.38 83.136-42.608 9.8868 63.646 8.5386 3.4619-16.178z",
    style: {
      fillRule: "evenodd",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#f67535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145 31.68-13.581 70.106 29.559-15.504 9.0542-45.165z",
    style: {
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145 31.68-13.581 70.106 29.559-15.504 9.0542-45.165z",
    style: {
      fillRule: "evenodd",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#f67535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-391.33 112.45h960v104.38h-960z",
    style: {
      fillOpacity: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8de2bebfcd99966406f962c2972ac1ca.svg";
export { ForwardRef as ReactComponent };